import styled from 'styled-components'

import { Flex } from '@/atoms/layout'

export const FieldArrayWrapper = styled(Flex)`
  flex-wrap: wrap;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => theme.space.S12};
  }
`
